// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Configuration_einstellungen__zzEW7 {
    position: relative;

}
.Configuration_einstellungenWrapper__1jme0 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 40px 0px;
}
.Configuration_headerframe__wvi9N {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
}
.Configuration_growsetupname__CnMaz {
    width: 100%;
    border-radius: 6px;
    background-color: #0f141c;
    border: 1px solid #222d41;
    box-sizing: border-box;
    height: 69px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    min-width: 400px;
}
.Configuration_unbenanntesProjekt22__wS1v- {
    width: 60%;
    position: relative;
    height: 245px;
    object-fit: cover;
}
.Configuration_hinzufgen__SssIl {
    position: absolute;
    display: inline-block;
    width: 117px;
    height: 32px;
}
.Configuration_hinzufgenWrapper__zdHlj {
    width: 103px;
    position: relative;
    border-radius: 8px;
    background-color: #77a78c;
    height: 64px;
    overflow: hidden;
    flex-shrink: 0;
}
.Configuration_entfernen__QI2mM {
    position: absolute;
    top: 25%;
    left: 5%;
}
.Configuration_entfernenWrapper__REAAF {
    width: 102px;
    position: relative;
    border-radius: 8px;
    background-color: #b03333;
    border: 1px solid #000;
    box-sizing: border-box;
    height: 64px;
    overflow: hidden;
    flex-shrink: 0;
}
.Configuration_devicebuttons__O\\+kwY {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 9px 27px;
    gap: 29px;
}
.Configuration_klimakontroller__GW8OB {
    flex: 1 1;
    border-radius: 6px;
    background-color: #0f141c;
    border: 1px solid #222d41;
    box-sizing: border-box;
    height: 435px;
    display: flex;
    width:49%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    gap: 21px;
    min-width: 400px;
}
.Configuration_headerframe2__cikqB {
    width: 443px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
}
.Configuration_unbenanntesProjekt91__IQoqd {
    width: 60%;
    position: relative;
    height: 239px;
    object-fit: cover;
}
.Configuration_hydrokontroller__1GBmy {
    flex: 1 1;
    border-radius: 6px;
    background-color: #0f141c;
    border: 1px solid #222d41;
    box-sizing: border-box;
    height: 435px;
    display: flex;
    width:49%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    gap: 21px;
    min-width: 400px;
}
.Configuration_growSetupLschen__aBc28 {
    margin: 0;
}
.Configuration_growSetupLschenContainer__CTrmo {
    width: 231px;
    position: relative;
    display: inline-block;
    height: 29px;
    flex-shrink: 0;
}
.Configuration_growSetupLschenWrapper__SjJh7 {
    width: 259px;
    background-color: #be1616;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.Configuration_growsetuplschen__jXn-P {
    width: 'hug';
    border-radius: 6px;
    background-color: #0f141c;
    border: 1px solid #222d41;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 20px;
    min-width: 400px;
}
.Configuration_cards__-VbZa {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 20px;
    font-size: 21px;
}
.Configuration_content__igg0T {
    flex: 1 1;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    padding: 0px 40px;
    box-sizing: border-box;
    text-align: left;
    font-size: 36px;
    color: #fff;
    font-family: 'Noto Sans';
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.Configuration_overlay__PHDON {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(128,128,128,0.75);
    pointer-events: none; /* Prevents any mouse interactions */
}`, "",{"version":3,"sources":["webpack://./src/css/Configuration.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;AAEtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;AACA;IACI,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,oBAAoB,EAAE,oCAAoC;AAC9D","sourcesContent":[".einstellungen {\n    position: relative;\n\n}\n.einstellungenWrapper {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 40px 0px;\n}\n.headerframe {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n}\n.growsetupname {\n    width: 100%;\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: 1px solid #222d41;\n    box-sizing: border-box;\n    height: 69px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 20px;\n    min-width: 400px;\n}\n.unbenanntesProjekt22 {\n    width: 60%;\n    position: relative;\n    height: 245px;\n    object-fit: cover;\n}\n.hinzufgen {\n    position: absolute;\n    display: inline-block;\n    width: 117px;\n    height: 32px;\n}\n.hinzufgenWrapper {\n    width: 103px;\n    position: relative;\n    border-radius: 8px;\n    background-color: #77a78c;\n    height: 64px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n.entfernen {\n    position: absolute;\n    top: 25%;\n    left: 5%;\n}\n.entfernenWrapper {\n    width: 102px;\n    position: relative;\n    border-radius: 8px;\n    background-color: #b03333;\n    border: 1px solid #000;\n    box-sizing: border-box;\n    height: 64px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n.devicebuttons {\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 9px 27px;\n    gap: 29px;\n}\n.klimakontroller {\n    flex: 1;\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: 1px solid #222d41;\n    box-sizing: border-box;\n    height: 435px;\n    display: flex;\n    width:49%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 20px;\n    gap: 21px;\n    min-width: 400px;\n}\n.headerframe2 {\n    width: 443px;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n}\n.unbenanntesProjekt91 {\n    width: 60%;\n    position: relative;\n    height: 239px;\n    object-fit: cover;\n}\n.hydrokontroller {\n    flex: 1;\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: 1px solid #222d41;\n    box-sizing: border-box;\n    height: 435px;\n    display: flex;\n    width:49%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 20px;\n    gap: 21px;\n    min-width: 400px;\n}\n.growSetupLschen {\n    margin: 0;\n}\n.growSetupLschenContainer {\n    width: 231px;\n    position: relative;\n    display: inline-block;\n    height: 29px;\n    flex-shrink: 0;\n}\n.growSetupLschenWrapper {\n    width: 259px;\n    background-color: #be1616;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n.growsetuplschen {\n    width: 'hug';\n    border-radius: 6px;\n    background-color: #0f141c;\n    border: 1px solid #222d41;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    flex-wrap: wrap;\n    align-content: flex-start;\n    padding: 20px;\n    min-width: 400px;\n}\n.cards {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    align-content: flex-start;\n    gap: 20px;\n    font-size: 21px;\n}\n.content {\n    flex: 1;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 0px 40px;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: 36px;\n    color: #fff;\n    font-family: 'Noto Sans';\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(128,128,128,0.75);\n    pointer-events: none; /* Prevents any mouse interactions */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"einstellungen": `Configuration_einstellungen__zzEW7`,
	"einstellungenWrapper": `Configuration_einstellungenWrapper__1jme0`,
	"headerframe": `Configuration_headerframe__wvi9N`,
	"growsetupname": `Configuration_growsetupname__CnMaz`,
	"unbenanntesProjekt22": `Configuration_unbenanntesProjekt22__wS1v-`,
	"hinzufgen": `Configuration_hinzufgen__SssIl`,
	"hinzufgenWrapper": `Configuration_hinzufgenWrapper__zdHlj`,
	"entfernen": `Configuration_entfernen__QI2mM`,
	"entfernenWrapper": `Configuration_entfernenWrapper__REAAF`,
	"devicebuttons": `Configuration_devicebuttons__O+kwY`,
	"klimakontroller": `Configuration_klimakontroller__GW8OB`,
	"headerframe2": `Configuration_headerframe2__cikqB`,
	"unbenanntesProjekt91": `Configuration_unbenanntesProjekt91__IQoqd`,
	"hydrokontroller": `Configuration_hydrokontroller__1GBmy`,
	"growSetupLschen": `Configuration_growSetupLschen__aBc28`,
	"growSetupLschenContainer": `Configuration_growSetupLschenContainer__CTrmo`,
	"growSetupLschenWrapper": `Configuration_growSetupLschenWrapper__SjJh7`,
	"growsetuplschen": `Configuration_growsetuplschen__jXn-P`,
	"cards": `Configuration_cards__-VbZa`,
	"content": `Configuration_content__igg0T`,
	"overlay": `Configuration_overlay__PHDON`
};
export default ___CSS_LOADER_EXPORT___;
